"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconBookmark', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M2 3C2 1.89543 2.89543 1 4 1H12C13.1046 1 14 1.89543 14 3V13.822C14 14.6803 13.0608 15.2079 12.3278 14.7614L8 11.1253L3.67223 14.7614C2.93921 15.2079 2 14.6803 2 13.822V3ZM12 3H4V12.22L8 8.7835L12 12.22V3Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M3 3C3 1.89543 3.89543 1 5 1H15C16.1046 1 17 1.89543 17 3V17.7997C17 18.6839 16.0096 19.2068 15.2795 18.708L10.0007 14.1015L4.72165 18.7178C3.99165 19.2178 3 18.6951 3 17.8103V3ZM15 3H5V16.1029L9.99925 11.6783L15 16.0948V3Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M6.11111 3C6.04975 3 6 3.04975 6 3.11111V20.0256L11.9992 14.6225L18 20.0151V3.11111C18 3.04975 17.9503 3 17.8889 3H6.11111ZM4 3.11111C4 1.94518 4.94518 1 6.11111 1H17.8889C19.0548 1 20 1.94518 20 3.11111V21.7674C20 22.677 18.9666 23.2012 18.2326 22.6639L12.0008 17.1023L5.76854 22.6764C5.03466 23.215 4 22.6909 4 21.7806V3.11111Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M7.39683 4C7.17766 4 7 4.17766 7 4.39683V27.1296L15.9993 20.1191L25 27.1146V4.39683C25 4.17766 24.8223 4 24.6032 4H7.39683ZM5 4.39683C5 3.0731 6.0731 2 7.39683 2H24.6032C25.9269 2 27 3.0731 27 4.39683V28.7214C27 29.6315 25.9859 30.1745 25.2285 29.6699L16.0007 22.5232L6.77267 29.6865C6.01535 30.1923 5 29.6494 5 28.7387V4.39683Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;